var fromEmailUpdRqst = false;

const submitEmailSignupForm = (form) => {
	var data = $(form).serialize();

	function myCallback(form) {}
	$.ajax({
		url: '/webapp/wcs/stores/servlet/EmailSignup',
		cache: false,
		type: 'POST',
		data: data + '&storeId=301&langId=-1&catalogId=301',
		success: function (json) {
			var errorResp = json.JSONError;
			if (errorResp != null) {
				$('#updateErrors').html(errorResp);
			} else {
				if (fromEmailUpdRqst) {
					dataLayer.flags = {};
					dataLayer.flags.emailUpdRqstComplete = 'Y';
				} else {
					dataLayer.flags = {};
					dataLayer.flags.emailPrefRqstComplete = 'Y';
				}
				$('#dynamicModalContainer button')[0].click();
			}
		},
		error: function (json) {
			$('#dynamicModalContainer button')[0].click();
		},
	});
};

const ajaxEmailSignup = (params, returnHTML) => {
	var $form = $('#' + params.formId),
		emailAddress = $form.find("input[name*='recipientEmail'],input[name*='userEmail']").val();

	function myCallback(params) {}

	var fromLightParam = '';
	if (params.formId == 'emailSignupLightbox') {
		fromLightParam = '&fromLight=true';
	}

	$.ajax({
		cache: true,
		type: 'POST',
		url: '/webapp/wcs/stores/servlet/EmailSignup',
		data: 'emailAddress=' + emailAddress + '&launchModal=Y&launchModal=Y&storeId=301&langId=-1&catalogId=301' + fromLightParam,
		beforeSend: function () {
			$('#recipientEmail').val('');
		},
		success: function (json) {
			if (json.indexOf('emailSignupUpdateForm') > 0) {
				dataLayer.flags = {};
				dataLayer.flags.emailUpdRqstInitiate = 'Y';
				fromEmailUpdRqst = true;
			}
			if (json.indexOf('emailSignupForm') > 0) {
				dataLayer.flags = {};
				dataLayer.flags.emailSignupInitiateFooter = 'Y';
				dataLayer.flags.emailSignupCompleteFooter = 'Y';
				dataLayer.flags.emailPreferenceRqstInitiate = 'Y';
			}
			returnHTML(json, myCallback);
		},
		error: function (json) {
			returnHTML(json, myCallback);
		},
	});
};

var emailSignupScroll = () => {
	$('.footerSubmit').on('click', function () {
		$('#recipientEmail').blur();
		if (!$(this).parent('.emailInput').hasClass('has-error')) {
			$('html, body').animate(
				{
					scrollTop: $('.modal-content'),
				},
				500
			);
		}
	});
};

export { submitEmailSignupForm, ajaxEmailSignup, emailSignupScroll };
